var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.105 0H7.895A7.895 7.895 0 0 0 0 7.895v27.21A7.895 7.895 0 0 0 7.895 43h297.21A7.895 7.895 0 0 0 313 35.105V7.895A7.895 7.895 0 0 0 305.105 0z",
    fill: "#fff",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 10,
    width: 22,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.776 21.499c0-5.918-4.797-10.715-10.715-10.715S66.346 15.58 66.346 21.499s4.797 10.715 10.715 10.715 10.715-4.797 10.715-10.715z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.776 21.499c0-5.918-4.797-10.715-10.715-10.715S66.346 15.58 66.346 21.499s4.797 10.715 10.715 10.715 10.715-4.797 10.715-10.715z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.539 21.878c.335.247.67.423.67.794 0 .105-.141.229-.459.229-.246 0-.493-.07-.634-.247-.106-.123.035-.317-.036-.44-.07-.107-.211-.054-.317-.107-.106-.07-.123-.105-.211-.282-.089-.194-.388-.529-.74-.881-.3-.3-.618-.458-.759-.44-.075.014-.152.02-.229.017-.264 0-.476.247-.846.405-.265.106-.406.177-.564.194l-.053.07.335-.017c.317 0 .722-.035 1.022-.035.317 0 .476.282.6.582.246.599.599 1.463 1.04 2.203.211.335.388.564.388.987 0 .124-.018.318-.194.318-.247 0-.864-.265-.864-.53 0-.21.176-.299.176-.51 0-.124-.194-.106-.247-.23-.158-.634-.335-1.286-.705-1.674-.194-.194-.211-.282-.405-.282-.106 0-.194.035-.282.053-.494.194-1.164.758-2.01 1.004-.317.106-.37-.088-.705-.035h.035c-.264.053-.476.212-.846.317-.494.142-1.375.212-2.08.106-.494-.07-1.146-.176-1.41-.158-.212.599-.653 1.392-1.323 1.71-.352.158-.458.37-.352.775.123.494.564.864.793 1.287.212.353.564.934.917 1.128.352.194.581.459.581.706 0 .105-.035.176-.158.176h-.705a.229.229 0 0 1-.194-.106c-.106-.194-.036-.353-.177-.529-.105-.106-.176-.088-.3-.194-.21-.211-.052-.335-.21-.6-.46-.722-.653-.898-1.041-1.427-.212-.265-.494-.423-.494-.776 0-.44.441-.511.423-.952-.281.212-.616.37-1.128.441a.9.9 0 0 0-.317.23c-.176.176-.247.352-.264.616-.053.6-.177 1.199-.106 1.798.106.388.176.512.493.723.194.123.423.317.459.6 0 .07-.035.176-.124.176h-.793c-.07 0-.141-.053-.176-.106-.088-.159-.035-.264-.07-.44-.071-.353-.494-.336-.494-.723 0-.106.07-.265.07-.494.035-.494.176-1.322.035-2.31-.07-.564.53-.599.847-1.092.194-.282.123-.177.246-.37a.759.759 0 0 0 .07-.494c0-.176-.175-.511-.052-1.234.035-.318.194-.635.423-.917 0-.018 0-.053-.07-.053-.318.035-.318-.053-.512-.053s-.352.177-.388.265c-.105-.036-.14-.159-.14-.212 0-.106.035-.211.123-.317.035-.035 0-.07-.053-.07-.247 0-.476.299-.529.493-.14-.035-.159-.212-.211-.212-.07 0-.106.106-.106.194 0 .706 1.146.864 1.146 1.78 0 1.076-1.287.847-1.287 1.235 0 .07.053.14.158.194-.035.106-.158.14-.264.14a.482.482 0 0 1-.494-.493c0-.582.794-.6.794-1.04 0-.212-.124-.264-.265-.37-.74-.529-1.163-1.058-1.163-1.922 0-.934.652-1.657 1.498-1.657 1.234 0 1.27 1.428 2.38 1.552.423-.282.917-.459 1.393-.459.722 0 1.04.194 1.816.194.317 0 .828-.088 1.445-.511.23-.159.335-.194.547-.37.493-.423.934-1.234.934-1.816v.035c0-.194-.035-.3-.124-.3-.264 0-.493.247-.758.494-.176.176.089.265-.282.459-.123.07-.282-.053-.423-.053-.3 0-.423-.353-.423-.653 0-.158.106-.194.194-.335.159-.3.141-.423.282-.705.088-.194.247-.335.23-.476 0-.053-.036-.088-.036-.14 0-.3.406-.494.406-.794 0-.176-.194-.247-.23-.37-.105-.212-.07-.265-.07-.265.018-.035.035-.035.053-.035.158 0 .211.176.352.264.018-.193-.053-.246-.053-.387 0-.07 0-.194.071-.194.106 0 .088.123.176.194.106.088.212.07.335.158.159.106.247.265.3.265.159.035.194-.177.106-.265.176-.017.352.124.581.124.353 0 .494.105.564.158.23.194.265.353.53.353.123 0 .193-.106.229-.159.176.124.194.459 0 .74.07.23.405.265.564.37.158.107.123.177.246.23a.213.213 0 0 0 .23 0c.07.317-.194.582-.512.635.018.405.424.634.617.74-.105.247-.317.317-.493.353.053.247.317.599.194.916-.106-.052-.3 0-.3.177 0 .194.264.3-.018.44-.105.07-.14.247.07.424.283-.071.565-.071.882-.071.194 0 .459-.053.635-.053.335 0 .529.123.776.405.617.635 1.163 1.34 1.798 1.816z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.18 20.115c.123 0 .37-.723.863-.723.141 0 .176.053.176.106 0 .106-.176.194-.176.318 0 .035.018.052.053.052.106 0 .212-.264.705-.264.124 0 .247.018.353.035.053.018.176.07.106-.088-.106-.335-.494-.652-1.023-.652-.529 0-1.093.476-1.146 1.04.035.106.036.176.089.176zm9.149-4.548c-.141-.053-.177-.123-.106-.317.035-.194.035-.264-.035-.282-.07-.035-.177.035-.265.123-.088.106-.229.265-.264.388-.035.159.14.123.017.388-.229.423-.282.51-.405.793-.106.317-.176.353-.23.459-.07.088.089.105.265.035.194-.07.194.158.124.317-.053.106-.018.159.14.035.142-.105-.07-.194-.035-.564.053-.317.106-.493.318-.81.176-.265.317-.477.6-.37.087.07.034-.124-.124-.195zm6.117 9.36c.053 0 .07-.07.07-.14 0-.16-.088-.388-.211-.493-.036.229-.141.387-.141.493 0 .07.211.14.282.14zm1.374-2.22c.089 0 .212-.035.212-.106 0-.123-.194-.352-.37-.423.124.247-.001.529.158.529zm-6.063-3.015c1.251.564 1.163 1.622 1.269 1.358a1.114 1.114 0 0 0-.23-1.13c-.334-.404-.475-.3-.334-.633.546-1.322.881-3.297-.74-3.984-.195-.07-.336-.07-.336-.035s.177.088.388.229c1.093.723.74 2.68-.247 3.614-.317.334-.158.405.23.58zm-4.249 9.149c.088 0 .035-.123.018-.193-.07-.124-.212-.212-.335-.265.035.123.035.458.176.458h.141zm-3.755 0c.088 0 .035-.123-.017-.193-.07-.124-.23-.212-.353-.265.035.123.053.458.194.458h.176zm4.549-7.474c.687-.07.793-.23.916-.74.053-.247.23-.494.388-.653.106-.105.194-.194.3-.352.035-.07.053-.106 0-.106-.07.053-.318.212-.423.282-.494.335-1.234.494-1.517.494-.634 0-1.163-.194-1.745-.194-1.71 0-2.362 1.34-2.274 2.133.018.123.035.123.07.123.107 0 .23-.458.653-.864.635-.6 1.322-.934 2.292-.934.705 0 1.004.23 1.004.317 0 .177-.3.194-.264.353-.017.07.141.212.6.14z",
    fill: "#6D6E70"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 10,
    width: 22,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.495 21.499c0-5.918-4.797-10.715-10.715-10.715S53.065 15.58 53.065 21.499s4.797 10.715 10.715 10.715 10.715-4.797 10.715-10.715z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.78 32.214c5.918 0 10.715-4.797 10.715-10.715S69.698 10.784 63.78 10.784 53.065 15.58 53.065 21.499s4.797 10.715 10.715 10.715z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.082 14.045c-.312 0-1.24 0-2.318 1.31l.042.05a4.78 4.78 0 0 1 .997-.896c.345-.223.744-.37 1.075-.407.241-.027 1.039-.017 1.947-.017.004 0 .007.003.01.005l-.024-.04a.01.01 0 0 0-.009-.005h-1.72z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.759 14.045a.01.01 0 0 0-.01.005l-4.558 7.896-.016.027c0 .002 0 .006.002.01l3.216 5.572v-.024a3.926 3.926 0 0 1-.146-.288 2.634 2.634 0 0 1-.191-1.136c.054-1.078.628-2.143.916-2.642l1.984-3.437 1.984-3.438c.288-.498.924-1.527 1.831-2.114.325-.212.693-.35 1.078-.402.242-.027 1.044-.029 1.953-.029h-8.043z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.383 23.66a2.632 2.632 0 0 1-.887.732c-.962.493-2.17.528-2.746.528h-7.938c-.576 0-1.786-.035-2.746-.528a2.629 2.629 0 0 1-.889-.732c-.124-.17-.446-.716-.824-1.371l3.845 6.66a.01.01 0 0 0 .009.005h9.148c.003 0 .006-.003.008-.006l3.986-6.903c-.44.76-.826 1.424-.966 1.615z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85 14.074c-.33.036-.735.18-1.079.402-.38.246-.711.569-.99.898.387.457.672.926.84 1.216l3.97 6.875c.287.5.86 1.564.914 2.642.02.41-.057.83-.19 1.136-.093.213-.464.86-.894 1.606l3.965-6.867v-.01l-4.575-7.921c-.002-.004-.005-.006-.009-.006-.909 0-1.71.002-1.952.029z",
    fill: "url(#j)"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 10,
    width: 23,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.215 21.499c0-5.918-4.797-10.715-10.715-10.715S39.785 15.58 39.785 21.499 44.582 32.214 50.5 32.214s10.715-4.797 10.715-10.715z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.215 21.499c0-5.918-4.797-10.715-10.715-10.715S39.785 15.58 39.785 21.499 44.582 32.214 50.5 32.214s10.715-4.797 10.715-10.715z",
    fill: "#2857AF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.976 17.765c0-.792.692-1.435 1.54-1.435.849 0 1.54.643 1.54 1.435 0 .79-.691 1.432-1.54 1.432-.848 0-1.54-.642-1.54-1.432z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.356 19.297v-2.492l6.156 3.48 6.164-3.476V19.3l-3.95 2.206 3.95 2.205v2.496l-6.16-3.475-6.16 3.475v-2.496l3.947-2.205-3.947-2.21z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.348 21.507c0-.793.689-1.436 1.536-1.436.853 0 1.54.643 1.54 1.436 0 .791-.687 1.435-1.54 1.435-.847 0-1.536-.644-1.536-1.435zm13.229 0c0-.793.69-1.436 1.54-1.436.85 0 1.536.643 1.536 1.436 0 .791-.686 1.435-1.536 1.435s-1.54-.644-1.54-1.435zm-6.601 3.726c0-.792.692-1.432 1.54-1.432.849 0 1.54.64 1.54 1.432 0 .792-.691 1.436-1.54 1.436-.848 0-1.54-.644-1.54-1.436z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 10,
    width: 22,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.935 21.499c0-5.918-4.797-10.715-10.715-10.715S26.505 15.58 26.505 21.499s4.797 10.715 10.715 10.715 10.715-4.797 10.715-10.715z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.22 32.214c5.918 0 10.715-4.797 10.715-10.715S43.138 10.784 37.22 10.784 26.505 15.58 26.505 21.499s4.797 10.715 10.715 10.715z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.935 21.499c0-5.918-4.797-10.715-10.715-10.715S26.505 15.58 26.505 21.499s4.797 10.715 10.715 10.715 10.715-4.797 10.715-10.715z",
    fill: "#F8D314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.22 23.37 4.942 4.897 1.95-1.932-4.943-4.896.962-.952v-1.933l.686-.68v1.58l.659.653 2.416-2.394.66.653c0-.408-.11-1.85-1.264-2.938-1.29-1.25-2.58-.517-3.02-.082l-2.334 2.313.577.57-1.291 1.28-1.29-1.252.576-.57-2.334-2.313c-.44-.436-1.73-1.17-3.02.081-1.181 1.116-1.264 2.53-1.264 2.938l.632-.625 2.416 2.393.66-.68v-1.578l.686.68v1.905l.96.952-4.887 4.87 1.95 1.93 4.915-4.87z",
    fill: "#000"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 10,
    width: 22,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.655 21.499c0-5.918-4.797-10.715-10.715-10.715S13.225 15.58 13.225 21.499s4.797 10.715 10.715 10.715 10.715-4.797 10.715-10.715z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.655 21.499c0-5.918-4.797-10.715-10.715-10.715S13.225 15.58 13.225 21.499s4.797 10.715 10.715 10.715 10.715-4.797 10.715-10.715z",
    fill: "#E90031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.655 21.499a10.715 10.715 0 0 1-21.43 0h21.43z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.243 20.83h13.394v1.339H17.243v-1.34z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.224 21.499a10.717 10.717 0 0 1 21.431 0H13.224z",
    fill: "#E90031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.636 22.169H17.243v-1.34h13.393v1.34z",
    fill: "#fff"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.459 22.676h-3.411v3.5h-2.382v-3.5h-3.41v-2.202h3.41v-3.5h2.382v3.5h3.411v2.202zm10.735-5.649h-5.847v3.086c.252-.313.613-.565 1.082-.758.47-.204.969-.307 1.498-.307.963 0 1.751.211 2.364.632.595.398 1.06.963 1.336 1.624.279.663.421 1.375.415 2.094 0 1.383-.397 2.496-1.191 3.338-.782.842-1.901 1.263-3.357 1.263-1.371 0-2.466-.342-3.284-1.028-.818-.686-1.282-1.582-1.39-2.69h2.454c.109.482.349.867.722 1.156.385.29.873.433 1.462.433.71 0 1.245-.223 1.606-.668.361-.445.542-1.034.542-1.768 0-.746-.187-1.312-.56-1.697-.361-.397-.896-.595-1.606-.595-.505 0-.926.126-1.263.38-.337.251-.578.59-.722 1.01h-2.418v-7.724h8.157v2.22zm2.229 4.223c0-2.08.373-3.712 1.119-4.89.758-1.18 2.01-1.77 3.754-1.77 1.745 0 2.99.59 3.736 1.77.758 1.178 1.137 2.81 1.137 4.89 0 2.093-.379 3.736-1.137 4.927-.746 1.19-1.991 1.786-3.736 1.786-1.744 0-2.996-.595-3.754-1.786-.746-1.19-1.119-2.834-1.119-4.927zm7.255 0c0-.89-.06-1.636-.18-2.238-.109-.613-.337-1.113-.686-1.498-.337-.384-.842-.577-1.516-.577s-1.185.193-1.534.578c-.337.384-.565.884-.686 1.497-.108.602-.162 1.348-.162 2.238 0 .915.054 1.684.162 2.31.109.614.337 1.113.686 1.498.349.373.86.56 1.534.56s1.185-.187 1.534-.56c.349-.385.577-.884.686-1.498.108-.625.162-1.395.162-2.31zm3.871 0c0-2.08.373-3.712 1.119-4.89.758-1.18 2.009-1.77 3.753-1.77 1.745 0 2.99.59 3.736 1.77.758 1.178 1.137 2.81 1.137 4.89 0 2.093-.379 3.736-1.137 4.927-.746 1.19-1.991 1.786-3.736 1.786-1.744 0-2.995-.595-3.753-1.786-.746-1.19-1.119-2.834-1.119-4.927zm7.255 0c0-.89-.061-1.636-.181-2.238-.108-.613-.337-1.113-.686-1.498-.337-.384-.842-.577-1.516-.577-.673 0-1.185.193-1.534.578-.336.384-.565.884-.685 1.497-.109.602-.163 1.348-.163 2.238 0 .915.054 1.684.163 2.31.108.614.337 1.113.685 1.498.349.373.861.56 1.534.56.674 0 1.185-.187 1.534-.56.349-.385.578-.884.686-1.498.108-.625.163-1.395.163-2.31zm15.064.29a2.83 2.83 0 0 1 1.751 1.064c.452.562.694 1.264.685 1.985 0 .674-.168 1.27-.505 1.786-.325.506-.8.903-1.426 1.191-.625.29-1.365.433-2.219.433h-5.432V15.404h5.197c.854 0 1.588.138 2.202.415.625.277 1.095.662 1.407 1.155.325.493.488 1.053.488 1.678 0 .734-.199 1.348-.596 1.841-.385.493-.902.842-1.552 1.047zm-4.62-.94h2.31c.602 0 1.065-.132 1.39-.397.325-.276.487-.667.487-1.173 0-.505-.162-.896-.487-1.173-.325-.276-.788-.415-1.39-.415h-2.31V20.6zm2.545 5.342c.613 0 1.089-.144 1.425-.433.349-.289.524-.698.524-1.227 0-.54-.181-.963-.542-1.263-.36-.313-.848-.47-1.461-.47h-2.491v3.393h2.545zm5.334-2.978c0-1.01.198-1.906.596-2.688.409-.782.956-1.384 1.642-1.805a4.417 4.417 0 0 1 2.328-.632c.746 0 1.395.15 1.949.451.565.301 1.016.68 1.353 1.137v-1.425h2.545V28h-2.545v-1.46c-.325.468-.776.86-1.353 1.172-.566.3-1.221.45-1.967.45a4.296 4.296 0 0 1-2.31-.649c-.686-.433-1.233-1.04-1.642-1.822-.398-.794-.596-1.703-.596-2.726zm7.868.037c0-.614-.12-1.137-.361-1.57a2.464 2.464 0 0 0-.974-1.01 2.553 2.553 0 0 0-1.318-.362c-.469 0-.902.114-1.299.343-.41.242-.747.591-.974 1.01-.241.434-.361.951-.361 1.552 0 .602.12 1.131.361 1.59.252.444.577.787.974 1.027.409.24.842.361 1.299.361.47 0 .909-.114 1.318-.343.41-.242.747-.591.974-1.01.241-.445.361-.975.361-1.588zm10.011-5.144c1.191 0 2.154.38 2.888 1.137.734.746 1.101 1.793 1.101 3.14V28h-2.527v-5.522c0-.794-.198-1.4-.595-1.822-.398-.433-.939-.65-1.625-.65-.697 0-1.251.216-1.66.65-.397.42-.595 1.028-.595 1.822V28h-2.527v-9.997h2.527v1.245c.336-.433.763-.77 1.281-1.01a3.969 3.969 0 0 1 1.732-.38zM185.775 28l-3.393-4.258V28h-2.526V14.645h2.526v7.598l3.357-4.24h3.284l-4.403 5.016 4.439 4.98h-3.284zm7.904.163c-.818 0-1.552-.144-2.202-.433-.649-.3-1.167-.704-1.552-1.21a3.076 3.076 0 0 1-.613-1.678h2.544c.049.385.235.704.56.957.337.253.752.38 1.245.38.481 0 .854-.097 1.119-.29.277-.192.415-.44.415-.74 0-.325-.168-.565-.505-.722-.325-.168-.848-.349-1.57-.54-.746-.18-1.36-.368-1.841-.56a3.274 3.274 0 0 1-1.227-.885c-.337-.397-.506-.932-.506-1.606 0-.553.157-1.059.47-1.516.324-.457.782-.818 1.371-1.083.602-.264 1.306-.397 2.112-.397 1.191 0 2.141.301 2.851.903.71.59 1.101 1.39 1.173 2.4h-2.418a1.272 1.272 0 0 0-.506-.939c-.288-.24-.679-.36-1.173-.36-.457 0-.812.084-1.064.252a.81.81 0 0 0-.361.704c0 .337.168.596.505.776.337.168.86.343 1.57.523.722.18 1.318.367 1.787.56.469.192.872.493 1.209.902.349.397.529.927.541 1.588 0 .578-.162 1.095-.487 1.552-.313.457-.77.818-1.372 1.083-.589.253-1.281.38-2.075.38zm11.752-12.759V28h-2.526V15.404h2.526zm7.495 2.454c1.191 0 2.154.38 2.888 1.137.733.746 1.1 1.793 1.1 3.14V28h-2.526v-5.522c0-.794-.199-1.4-.596-1.822-.397-.433-.938-.65-1.624-.65-.698 0-1.251.216-1.66.65-.397.42-.596 1.028-.596 1.822V28h-2.526v-9.997h2.526v1.245c.337-.433.764-.77 1.282-1.01a3.969 3.969 0 0 1 1.732-.38zm9.675 10.305c-.818 0-1.552-.144-2.201-.433-.65-.3-1.167-.704-1.552-1.21a3.077 3.077 0 0 1-.614-1.678h2.545c.048.385.234.704.559.957.337.253.752.38 1.245.38.482 0 .855-.097 1.119-.29.277-.192.415-.44.415-.74 0-.325-.168-.565-.505-.722-.325-.168-.848-.349-1.57-.54-.746-.18-1.36-.368-1.841-.56a3.274 3.274 0 0 1-1.227-.885c-.337-.397-.505-.932-.505-1.606 0-.553.156-1.059.469-1.516.325-.457.782-.818 1.372-1.083.601-.264 1.305-.397 2.111-.397 1.191 0 2.141.301 2.851.903.71.59 1.101 1.39 1.173 2.4h-2.418a1.272 1.272 0 0 0-.505-.939c-.289-.24-.68-.36-1.173-.36-.457 0-.812.084-1.065.252a.81.81 0 0 0-.361.704c0 .337.169.596.505.776.337.168.861.343 1.57.523.722.18 1.318.367 1.787.56.469.192.872.493 1.209.902.349.397.53.927.542 1.588 0 .578-.163 1.095-.488 1.552-.312.457-.77.818-1.371 1.083-.59.253-1.282.38-2.076.38zm8.409-8.085v4.837c0 .336.078.583.234.74.169.144.445.216.83.216h1.173V28h-1.588c-2.129 0-3.194-1.035-3.194-3.105v-4.818h-1.191v-2.075h1.191V15.53h2.545v2.473h2.237v2.075h-2.237zm2.864 2.887c0-1.01.198-1.906.595-2.688.409-.782.957-1.384 1.642-1.805a4.417 4.417 0 0 1 2.328-.632c.746 0 1.396.15 1.949.451.566.301 1.017.68 1.354 1.137v-1.425h2.544V28h-2.544v-1.46c-.325.468-.776.86-1.354 1.172-.565.3-1.221.45-1.967.45a4.296 4.296 0 0 1-2.31-.649c-.685-.433-1.233-1.04-1.642-1.822-.397-.794-.595-1.703-.595-2.726zm7.868.037c0-.614-.12-1.137-.361-1.57a2.47 2.47 0 0 0-.975-1.01 2.553 2.553 0 0 0-1.317-.362c-.469 0-.902.114-1.299.343a2.64 2.64 0 0 0-.975 1.01c-.24.434-.361.951-.361 1.552 0 .602.121 1.131.361 1.59.253.444.578.787.975 1.027.409.24.842.361 1.299.361.469 0 .908-.114 1.317-.343a2.63 2.63 0 0 0 .975-1.01c.241-.445.361-.975.361-1.588zm10.011-5.144c1.191 0 2.153.38 2.887 1.137.734.746 1.101 1.793 1.101 3.14V28h-2.526v-5.522c0-.794-.199-1.4-.596-1.822-.397-.433-.938-.65-1.624-.65-.698 0-1.251.216-1.66.65-.397.42-.596 1.028-.596 1.822V28h-2.526v-9.997h2.526v1.245c.337-.433.764-.77 1.281-1.01a3.973 3.973 0 0 1 1.733-.38zm8.791 2.22v4.837c0 .336.078.583.235.74.168.144.445.216.83.216h1.173V28h-1.588c-2.13 0-3.195-1.035-3.195-3.105v-4.818h-1.191v-2.075h1.191V15.53h2.545v2.473h2.238v2.075h-2.238zm16.458-.776c0 .674-.162 1.306-.487 1.895-.313.59-.812 1.065-1.498 1.426-.674.36-1.528.541-2.563.541h-2.111V28h-2.527V15.404h4.638c.975 0 1.805.168 2.491.505.685.337 1.197.8 1.534 1.39.348.59.523 1.256.523 2.002zm-4.656 1.823c.698 0 1.215-.157 1.552-.47.337-.324.505-.775.505-1.353 0-1.227-.686-1.84-2.057-1.84h-2.003v3.663h2.003zm5.259 1.84c0-1.01.198-1.906.595-2.688.409-.782.957-1.384 1.642-1.805a4.417 4.417 0 0 1 2.328-.632c.746 0 1.396.15 1.949.451.566.301 1.017.68 1.354 1.137v-1.425h2.544V28h-2.544v-1.46c-.325.468-.776.86-1.354 1.172-.565.3-1.221.45-1.967.45a4.296 4.296 0 0 1-2.31-.649c-.685-.433-1.233-1.04-1.642-1.822-.397-.794-.595-1.703-.595-2.726zm7.868.037c0-.614-.12-1.137-.361-1.57a2.466 2.466 0 0 0-.975-1.01 2.553 2.553 0 0 0-1.317-.362c-.469 0-.902.114-1.299.343a2.64 2.64 0 0 0-.975 1.01c-.24.434-.361.951-.361 1.552 0 .602.121 1.131.361 1.59.253.444.578.787.975 1.027.409.24.842.361 1.299.361.469 0 .908-.114 1.317-.343.41-.24.734-.577.975-1.01.241-.445.361-.975.361-1.588zm14.035-5-6.19 14.727h-2.689l2.166-4.98-4.006-9.746h2.833l2.581 6.984 2.616-6.984h2.689z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M305.105 1H7.895A6.895 6.895 0 0 0 1 7.895v27.21A6.895 6.895 0 0 0 7.895 42h297.21A6.895 6.895 0 0 0 312 35.105V7.895A6.895 6.895 0 0 0 305.105 1z",
    stroke: "url(#r)",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M305.105 1H7.895A6.895 6.895 0 0 0 1 7.895v27.21A6.895 6.895 0 0 0 7.895 42h297.21A6.895 6.895 0 0 0 312 35.105V7.895A6.895 6.895 0 0 0 305.105 1z",
    stroke: "url(#s)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 3.849,
    y: 4.087,
    width: 40.182,
    height: 40.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.679
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -50,
    y: -50,
    width: 413,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 52.952,
    y: 4.087,
    width: 48.218,
    height: 48.218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.697
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.697
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.160784 0 0 0 0 0.188235 0 0 0 0 0.301961 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 43.689,
    y: 4.087,
    width: 40.182,
    height: 40.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.679
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 30.409,
    y: 4.087,
    width: 40.182,
    height: 40.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.679
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 26.391,
    y: 4.087,
    width: 48.218,
    height: 48.218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.697
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.697
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.160784 0 0 0 0 0.188235 0 0 0 0 0.301961 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 17.129,
    y: 4.087,
    width: 40.182,
    height: 40.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.679
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 56.97,
    y: 4.087,
    width: 40.182,
    height: 40.182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.679
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_428_335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_428_335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(56.1725 0 0 145.698 78.65 158.792)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FBB809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EE960D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17A10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(18.1193 0 0 14.6705 69.72 14.045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FBB809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EE960D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17A10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.3393 0 0 28.602 56.136 17.619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FBB809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EE960D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17A10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.306 27.285) scale(13.3255)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FBB809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EE960D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D87301"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(117.167 106.374 75.706) scale(29.5759 178.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.009,
    stopColor: "#ECC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#EDB7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E99999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#E66F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#E74141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 88.364,
    y1: 0,
    x2: 92.778,
    y2: 48.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA7D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#D82681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanks);
export default __webpack_public_path__ + "static/media/banks.9daf310554f51d0da32eba30df364ca4.svg";
export { ForwardRef as ReactComponent };